import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `fuel_plan` anchor component.
 * Keep in sync with FuelPlanProps in src/ui/uiConfig/anchorComponents/FuelPlan/FuelPlan.types.ts
 */
export const fuelPlanPropDocs: ComponentDocMap = {
  headerTabs: {
    description: 'Top-level header tabs.',
    type: 'FuelPlanHeaderTab[]',
  },
  'headerTabs[].title': { description: 'Header tab title.', type: 'string' },
  'headerTabs[].tabs': { description: 'Sub-tabs inside this header tab.', type: 'FuelPlanTab[]' },
  'headerTabs[].tabs[].title': { description: 'Sub-tab title.', type: 'string' },
  'headerTabs[].tabs[].children_list': {
    description: 'Nested card/tree layout for this tab.',
    type: 'FuelPlanCell[]',
  },
  'headerTabs[].tabs[].override_alias': {
    description: 'Alias overrides for this tab.',
    type: 'UiConfigAliases',
  },
  'headerTabs[].tabs[].override_props': {
    description: 'Prop overrides for this tab.',
    type: 'UiConfigOverrideProps',
  },
  'headerTabs[].tabs[].children_list[].title': { description: 'Cell title.', type: 'string' },
  'headerTabs[].tabs[].children_list[].children_title': {
    description: 'Optional title for children section.',
    type: 'string',
  },
  'headerTabs[].tabs[].children_list[].ui_config_id': { description: 'Leaf child ui_config id.', type: 'number' },
  'headerTabs[].tabs[].children_list[].card_props': {
    description: 'Card visual behavior for this node.',
    type: '{ style: "table" | "default" | "sub"; default_collapsed: boolean; display: boolean }',
  },
  'headerTabs[].tabs[].children_list[].override_alias': {
    description: 'Cell-level alias override.',
    type: 'UiConfigAliases',
  },
  'headerTabs[].tabs[].children_list[].override_props': {
    description: 'Cell-level prop override.',
    type: 'UiConfigOverrideProps',
  },
  'headerTabs[].tabs[].children_list[].children_list': {
    description: 'Recursive nested cells.',
    type: 'FuelPlanCell[]',
  },
}
